module.exports = __webpack_public_path__ + "media/day/284-5a2c32e3.svg";